module.exports = __webpack_public_path__ + "static/media/research.8ada4074.jpg";